import React, { useState } from "react";
import {
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
  Button,
  Typography,
  Box,
  Container,
  Collapse,
  IconButton,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

const formatDate = (date) => {
  if (!date) return ""; // Handle empty values
  return new Date(date).toISOString().split("T")[0]; // ✅ Convert to "YYYY-MM-DD"
};

const today = formatDate(new Date());

const TravelPlanForm = ({onSubmit}) => {
  const [onward_journey , setOnwardJourney] = useState({
    placeFrom: "",
    placeTo: "",
    modeOfTravel: "",
    journeyStartDate: today,
    journeyStartTime: "",
    arrivalTime: "",
    trainNo: "",
  });

  const [return_journey, setReturnJourney] = useState({
    placeFrom: "",
    placeTo: "",
    modeOfTravel: "",
    journeyStartDate: today,
    journeyStartTime: "",
    arrivalTime: "",
    trainNo: "",
  });

  const [expanded, setExpanded] = useState(true); // Tracks if the form is expanded or collapsed

  const handleOnwardChange = (e) => {
    setOnwardJourney({ ...onward_journey , [e.target.name]: e.target.value });
  };

  const handleReturnChange = (e) => {
    setReturnJourney({ ...return_journey, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const finalData = {
      onward_journey,
      return_journey,
    };
    onSubmit(finalData)

    console.log("Onward Journey: ", onward_journey );
    console.log("Return Journey: ", return_journey );
  };

  const toggleExpand = () => {
    setExpanded(!expanded); // Toggles form expansion
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Container sx={{ width: "85%", maxWidth: "1200px" }}>
        {" "}
        {/* 85% width, max-width for responsiveness */}
        <Typography variant="h5" gutterBottom>
          Guest Travel Details
        </Typography>
        {/* Button to toggle form visibility */}
        <IconButton onClick={toggleExpand} style={{ marginBottom: "1rem" }}>
          {expanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
        {/* Form content */}
        <Collapse in={expanded}>
          <form onSubmit={handleSubmit}>
            {/* Onward Journey */}
            <Box mb={4}>
              <Typography variant="h6" className="mb-3">Onward Journey</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Place of Travel (Coming From)"
                    variant="outlined"
                    fullWidth
                    name="placeFrom"
                    value={onward_journey.placeFrom}
                    onChange={handleOnwardChange}
                    InputLabelProps={{
                      style: { fontSize: "1.5rem" },
                    }}
                    sx={{
                      "& .MuiInputLabel-root.Mui-focused": {
                        transform: "translate(14px, -7px) scale(0.5)", // ✅ Adjust position when focused
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Deboarding From Railway Station/Terminal"
                    variant="outlined"
                    fullWidth
                    name="placeTo"
                    value={onward_journey.placeTo}
                    onChange={handleOnwardChange}
                    InputLabelProps={{
                      style: { fontSize: "1.5rem" },
                    }}
                    sx={{
                      "& .MuiInputLabel-root.Mui-focused": {
                        transform: "translate(14px, -7px) scale(0.5)", // ✅ Adjust position when focused
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    sx={{
                      "& .MuiInputLabel-root.Mui-focused": {
                        transform: "translate(14px, -7px) scale(0.5)", // ✅ Adjust position when focused
                      },
                    }}
                  >
                    <InputLabel style={{ fontSize: "1.5rem" }}>
                      Mode of Travel
                    </InputLabel>
                    <Select
                      label="Mode of Travel"
                      name="modeOfTravel"
                      value={onward_journey.modeOfTravel}
                      onChange={handleOnwardChange}
                    >
                      <MenuItem value="Train">Train</MenuItem>
                      <MenuItem value="Flight">Flight</MenuItem>
                      <MenuItem value="Bus">Bus</MenuItem>

                      <MenuItem value="Own Vehicle">Own Vehicle</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label="Journey Start Date"
                    value={
                      onward_journey.journeyStartDate
                        ? new Date(onward_journey.journeyStartDate)
                        : null
                    } // ✅ Convert string to Date
                    onChange={(newValue) => {
                      setOnwardJourney((prev) => ({
                        ...prev,
                        journeyStartDate: formatDate(newValue) || today, // ✅ Always store "YYYY-MM-DD"
                      }));
                    }}
                    minDate={new Date()} // ✅ Prevent past dates
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Journey Start Time (HHMM)"
                    variant="outlined"
                    fullWidth
                    name="journeyStartTime"
                    value={onward_journey.journeyStartTime}
                    onChange={handleOnwardChange}
                    InputLabelProps={{
                      style: { fontSize: "1.5rem" },
                    }}
                    sx={{
                      "& .MuiInputLabel-root.Mui-focused": {
                        transform: "translate(14px, -7px) scale(0.5)", // ✅ Adjust position when focused
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Expected Arrival Time"
                    variant="outlined"
                    fullWidth
                    name="arrivalTime"
                    value={onward_journey.arrivalTime}
                    onChange={handleOnwardChange}
                    InputLabelProps={{
                      style: { fontSize: "1.5rem" },
                    }}
                    sx={{
                      "& .MuiInputLabel-root.Mui-focused": {
                        transform: "translate(14px, -7px) scale(0.5)", // ✅ Adjust position when focused
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Train No/Flight No/Other Details"
                    variant="outlined"
                    fullWidth
                    name="trainNo"
                    value={onward_journey.trainNo}
                    onChange={handleOnwardChange}
                    InputLabelProps={{
                      style: { fontSize: "1.5rem" },
                    }}
                    sx={{
                      "& .MuiInputLabel-root.Mui-focused": {
                        transform: "translate(14px, -7px) scale(0.5)", // ✅ Adjust position when focused
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Return Journey */}
            <Box mb={4}>
              <Typography variant="h6" className="mb-3">
                Return Journey
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Place of Travel (Coming From)"
                    variant="outlined"
                    fullWidth
                    name="placeFrom"
                    value={return_journey.placeFrom}
                    onChange={handleReturnChange}
                    InputLabelProps={{
                      style: { fontSize: "1.5rem" },
                    }}
                    sx={{
                      "& .MuiInputLabel-root.Mui-focused": {
                        transform: "translate(14px, -7px) scale(0.5)", // ✅ Adjust position when focused
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Deboarding From Railway Station/Terminal"
                    variant="outlined"
                    fullWidth
                    name="placeTo"
                    value={return_journey.placeTo}
                    onChange={handleReturnChange}
                    InputLabelProps={{
                      style: { fontSize: "1.5rem" },
                    }}
                    sx={{
                      "& .MuiInputLabel-root.Mui-focused": {
                        transform: "translate(14px, -7px) scale(0.5)", // ✅ Adjust position when focused
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    sx={{
                      "& .MuiInputLabel-root.Mui-focused": {
                        transform: "translate(14px, -7px) scale(0.5)", // ✅ Adjust position when focused
                      },
                    }}
                  >
                    <InputLabel style={{ fontSize: "1.5rem" }}>
                      Mode of Travel
                    </InputLabel>
                    <Select
                      label="Mode of Travel"
                      name="modeOfTravel"
                      value={return_journey.modeOfTravel}
                      onChange={handleReturnChange}
                    >
                      <MenuItem value="Train">Train</MenuItem>
                      <MenuItem value="Flight">Flight</MenuItem>
                      <MenuItem value="Bus">Bus</MenuItem>
                      <MenuItem value="Own Vehicle">Own Vehicle</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label="Journey Start Date"
                    value={
                      return_journey.journeyStartDate
                        ? new Date(return_journey.journeyStartDate)
                        : null
                    } // ✅ Convert string to Date
                    onChange={(newValue) => {
                      setReturnJourney((prev) => ({
                        ...prev,
                        journeyStartDate: formatDate(newValue) || today, // ✅ Always store "YYYY-MM-DD"
                      }));
                    }}
                    minDate={new Date()} // ✅ Prevent past dates
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Journey Start Time (HHMM)"
                    variant="outlined"
                    fullWidth
                    name="journeyStartTime"
                    value={return_journey.journeyStartTime}
                    onChange={handleReturnChange}
                    InputLabelProps={{
                      style: { fontSize: "1.5rem" },
                    }}
                    sx={{
                      "& .MuiInputLabel-root.Mui-focused": {
                        transform: "translate(14px, -7px) scale(0.5)", // ✅ Adjust position when focused
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Expected Arrival Time"
                    variant="outlined"
                    fullWidth
                    name="arrivalTime"
                    value={return_journey.arrivalTime}
                    onChange={handleReturnChange}
                    InputLabelProps={{
                      style: { fontSize: "1.5rem" },
                    }}
                    sx={{
                      "& .MuiInputLabel-root.Mui-focused": {
                        transform: "translate(14px, -7px) scale(0.5)", // ✅ Adjust position when focused
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Train No/Flight No/Other Details"
                    variant="outlined"
                    fullWidth
                    name="trainNo"
                    value={return_journey.trainNo}
                    onChange={handleReturnChange}
                    InputLabelProps={{
                      style: { fontSize: "1.5rem" },
                    }}
                    sx={{
                      "& .MuiInputLabel-root.Mui-focused": {
                        transform: "translate(12px, -7px) scale(0.5)", // ✅ Adjust position when focused
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
              >
                Submit
              </Button>
            </Box>
          </form>
        </Collapse>
      </Container>
    </LocalizationProvider>
  );
};

export default TravelPlanForm;
